// File: Admin.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Captcha from './Captcha'; 
import VisaPage from './VisaPage';
// Added FaCamera for the upload icon
import { FaUserShield, FaPassport, FaSignOutAlt, FaSave, FaPlaneDeparture, FaNewspaper, FaCamera, FaCheckCircle } from 'react-icons/fa';

// --- MANUAL COUNTRY LIST ---
const COUNTRY_LIST = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czechia", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine State", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

const Admin = () => {
    // 👇 --- API CONNECTION SETTINGS (Uncomment the one you want to use) --- 👇
    
    // 1. FOR LOCAL TESTING (Use this now):
    // const API_BASE_URL = "http://localhost:5000";
    
    // 2. FOR DEPLOYMENT (Use this when pushing to Vercel):
    const API_BASE_URL = "https://backend-new-steel-theta.vercel.app";
    
    // --------------------------------------------------------------------------

    // --- AUTHENTICATION STATE ---
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('isAdminLoggedIn') === 'true';
    });

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    // --- CAPTCHA STATE ---
    const [captchaInput, setCaptchaInput] = useState(''); 
    const [realCaptchaCode, setRealCaptchaCode] = useState(''); 
    const [refreshCaptcha, setRefreshCaptcha] = useState(false); 

    // --- DASHBOARD STATE ---
    const [activeTab, setActiveTab] = useState('visa'); 
    const [newsForm, setNewsForm] = useState({ title: '', image: '', description: '', content: '' });
    
    // --- COUNTRY LIST STATE (Now using static manual list) ---
    const [countryList] = useState(COUNTRY_LIST);

    // --- VISA FORM STATE ---
    const [visaForm, setVisaForm] = useState({
        referenceNumber: '', 
        passportNumber: '',
        surname: '', 
        firstName: '', 
        dob: '', 
        country: '', 
        validity: '', 
        type: '', 
        purpose: '',
        visaStatus: 'Approved', // Default Status
        photoUrl: '' 
    });

    const visaTypes = [
        "Select Type", "Tourist Visa", "Business Visa", "Student Visa", 
        "Work Permit", "Transit Visa", "Medical Visa", "Permanent Residence", "E-Visa"
    ];

    const validityOptions = [
        "Select Validity", "7 Days", "14 Days", "30 Days", "60 Days", 
        "90 Days", "180 Days", "1 Year", "2 Years", "3 Years", "5 Years", "10 Years"
    ];

    const statusOptions = ["Approved", "Canceled visa", "Rejected", "Pending"]; // New Status Options

    // --- HELPER: CONVERT IMAGE TO BASE64 ---
    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    // --- HANDLE FILE UPLOAD ---
    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 2 * 1024 * 1024) {
                alert("File is too large! Please select an image under 2MB.");
                return;
            }
            const base64 = await convertToBase64(file);
            setVisaForm({ ...visaForm, photoUrl: base64 });
        }
    };

    // --- LOGIN HANDLER ---
    const handleLogin = (e) => {
        e.preventDefault();
        if (captchaInput.toLowerCase() !== realCaptchaCode.toLowerCase()) {
            alert("❌ Incorrect CAPTCHA! Please try again.");
            setRefreshCaptcha(!refreshCaptcha); 
            setCaptchaInput(''); 
            return;
        }
        if (username === 'AdminVinodkumar123' && password === 'Vinodkumar123') {
            localStorage.setItem('isAdminLoggedIn', 'true');
            setIsAuthenticated(true);
        } else {
            alert("Incorrect Username or Password!");
            setRefreshCaptcha(!refreshCaptcha); 
            setPassword('');
        }
    };

    // --- LOGOUT HANDLER ---
    const handleLogout = () => {
        localStorage.removeItem('isAdminLoggedIn');
        setIsAuthenticated(false);
    };

    // --- VISA SUBMIT HANDLER ---
    const handleVisaSubmit = async (e) => {
        e.preventDefault();
        
        if(!visaForm.country || visaForm.country === "Select Nationality") {
            alert("Please select a valid Nationality.");
            return;
        }
        if(visaForm.type === "Select Type") {
            alert("Please select a valid Visa Type.");
            return;
        }

        try {
            await axios.post(`${API_BASE_URL}/api/visa`, visaForm);
            alert("✅ Visa Record Saved Successfully!");
            
            // Reset Form
            setVisaForm({ 
                referenceNumber: '', passportNumber: '', surname: '', firstName: '', 
                dob: '', country: '', validity: '', type: '', purpose: '', visaStatus: 'Approved', photoUrl: ''
            });
            document.getElementById('photoInput').value = ""; 
        } catch (error) {
            console.error(error);
            alert("❌ Error: Reference Number already exists or Server Issue.");
        }
    };

    // --- NEWS SUBMIT HANDLER ---
    const handleNewsSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_BASE_URL}/api/news`, newsForm);
            alert("News Posted Successfully!");
            setNewsForm({ title: '', image: '', description: '', content: '' });
        } catch (error) {
            console.error(error);
            alert("Error uploading news.");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setVisaForm({ ...visaForm, [name]: value });
    };

    // --- RENDER LOGIN SCREEN ---
    if (!isAuthenticated) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100" style={{ background: 'linear-gradient(135deg, #003366 0%, #0056b3 100%)' }}>
                <div className="card shadow-lg p-5 border-0" style={{ width: '420px', borderRadius: '20px', backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
                    <div className="text-center mb-4">
                        <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center" style={{width: '70px', height: '70px'}}>
                            <FaUserShield size={35} />
                        </div>
                        <h3 className="mt-3 fw-bold text-primary">Secure Admin</h3>
                    </div>
                    <form onSubmit={handleLogin}>
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="uName" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username" required />
                            <label htmlFor="uName">Username</label>
                        </div>
                        <div className="form-floating mb-3">
                            <input type="password" className="form-control" id="uPass" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
                            <label htmlFor="uPass">Password</label>
                        </div>

                        <div className="mb-4 p-3 bg-light border rounded-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <Captcha onCodeGenerated={setRealCaptchaCode} refreshTrigger={refreshCaptcha} />
                                <button type="button" className="btn btn-sm text-secondary" onClick={() => setRefreshCaptcha(!refreshCaptcha)}>↻ Refresh</button>
                            </div>
                            <input type="text" className="form-control text-center fw-bold letter-spacing-2" placeholder="Enter Security Code" value={captchaInput} onChange={(e) => setCaptchaInput(e.target.value)} maxLength={6} required />
                        </div>

                        <button type="submit" className="btn btn-primary w-100 py-3 fw-bold shadow-sm" style={{ borderRadius: '10px' }}>ACCESS DASHBOARD</button>
                    </form>
                </div>
            </div>
        );
    }

    // --- RENDER DASHBOARD ---
    return (
        <div className="container-fluid py-4" style={{ backgroundColor: '#f0f2f5', minHeight: '100vh' }}>
            <div className="container" style={{maxWidth: '1000px'}}>
                
                {/* HEADER */}
                <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-4 shadow-sm rounded-4">
                    <div>
                        <h2 className="m-0 fw-bold text-dark"><FaUserShield className="me-2 text-primary"/> Admin Dashboard</h2>
                        <p className="text-muted m-0 small">Manage Visas and News Updates</p>
                    </div>
                    <button className="btn btn-outline-danger d-flex align-items-center gap-2" onClick={handleLogout}>
                        <FaSignOutAlt /> Logout
                    </button>
                </div>

                {/* TABS */}
                <div className="d-flex gap-3 mb-4">
                    <button className={`btn flex-grow-1 py-3 fw-bold shadow-sm d-flex justify-content-center align-items-center gap-2 ${activeTab === 'visa' ? 'btn-primary' : 'btn-white bg-white text-secondary'}`} 
                        onClick={() => setActiveTab('visa')} style={{borderRadius: '12px'}}>
                        <FaPassport size={20}/> Manage Visas
                    </button>
                </div>

                <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
                    <div className="card-body p-5">
                        
                        {/* === VISA FORM === */}
                        {activeTab === 'visa' && (
                            <form onSubmit={handleVisaSubmit}>
                                <div className="d-flex align-items-center mb-4 border-bottom pb-3">
                                    <div className="bg-light p-3 rounded-circle me-3">
                                        <FaPlaneDeparture size={24} className="text-primary"/>
                                    </div>
                                    <div>
                                        <h4 className="fw-bold m-0 text-primary">Add Visa Application</h4>
                                        <small className="text-muted">Enter details exactly as they appear on the passport.</small>
                                    </div>
                                </div>

                                {/* SECTION 0: PHOTO UPLOAD */}
                                <div className="mb-4 p-3 bg-light border rounded d-flex align-items-center justify-content-between">
                                    <div className="flex-grow-1 me-3">
                                        <label className="form-label fw-bold text-secondary"><FaCamera className="me-2"/>Applicant Photo</label>
                                        <input 
                                            type="file" 
                                            id="photoInput"
                                            className="form-control" 
                                            accept="image/*" 
                                            onChange={handleFileChange} 
                                        />
                                        <small className="text-muted" style={{fontSize: '11px'}}>Supported: JPG, PNG. Max size: 2MB.</small>
                                    </div>
                                    {/* Image Preview */}
                                    {visaForm.photoUrl ? (
                                        <div className="text-center">
                                            <img src={visaForm.photoUrl} alt="Preview" className="rounded border bg-white" style={{width:'80px', height:'100px', objectFit:'cover'}} />
                                            <div style={{fontSize: '10px'}} className="text-success mt-1 fw-bold">Selected</div>
                                        </div>
                                    ) : (
                                        <div className="rounded border bg-white d-flex align-items-center justify-content-center text-muted" style={{width:'80px', height:'100px', fontSize: '10px'}}>
                                            No Image
                                        </div>
                                    )}
                                </div>

                                {/* SECTION 1: APPLICANT IDENTITY */}
                                <h6 className="text-secondary text-uppercase fw-bold mb-3 small tracking-wide">Applicant Identity</h6>
                                <div className="row g-3 mb-4">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" name="surname" value={visaForm.surname} onChange={handleInputChange} placeholder="Surname" required />
                                            <label>Surname (Last Name)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" name="firstName" value={visaForm.firstName} onChange={handleInputChange} placeholder="First Name" required />
                                            <label>First Name (Given Name)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" name="passportNumber" value={visaForm.passportNumber} onChange={handleInputChange} placeholder="Passport" required />
                                            <label>Passport Number</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="date" className="form-control" name="dob" value={visaForm.dob} onChange={handleInputChange} required />
                                            <label>Date of Birth</label>
                                        </div>
                                    </div>
                                </div>

                                {/* SECTION 2: VISA DETAILS */}
                                <h6 className="text-secondary text-uppercase fw-bold mb-3 small tracking-wide mt-4">Visa Details</h6>
                                <div className="row g-3">
                                    
                                    <div className="col-md-4">
                                        <div className="form-floating">
                                            <select className="form-select" name="country" value={visaForm.country} onChange={handleInputChange} required>
                                                <option value="">Select Nationality</option>
                                                {countryList.map((countryName, index) => (
                                                    <option key={index} value={countryName}>
                                                        {countryName}
                                                    </option>
                                                ))}
                                            </select>
                                            <label>Nationality</label>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-floating">
                                            <select className="form-select" name="type" value={visaForm.type} onChange={handleInputChange} required>
                                                {visaTypes.map((t, i) => <option key={i} value={t === "Select Type" ? "" : t}>{t}</option>)}
                                            </select>
                                            <label>Visa Type</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating">
                                            <select className="form-select" name="validity" value={visaForm.validity} onChange={handleInputChange} required>
                                                {validityOptions.map((v, i) => <option key={i} value={v === "Select Validity" ? "" : v}>{v}</option>)}
                                            </select>
                                            <label>Visa Validity</label>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control fw-bold text-primary" name="referenceNumber" value={visaForm.referenceNumber} onChange={handleInputChange} placeholder="Ref No" required />
                                            <label>Reference Number (Unique ID)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" name="purpose" value={visaForm.purpose} onChange={handleInputChange} placeholder="Purpose" />
                                            <label>Purpose of Visit</label>
                                        </div>
                                    </div>

                                    {/* 👇 NEW SECTION: VISA STATUS DROPDOWN 👇 */}
                                    <div className="col-12 mt-3">
                                        <div className="form-floating">
                                            <select 
                                                className="form-select border-2 border-warning fw-bold text-dark" 
                                                name="visaStatus" 
                                                value={visaForm.visaStatus} 
                                                onChange={handleInputChange} 
                                                required
                                            >
                                                {statusOptions.map((status, index) => (
                                                    <option key={index} value={status}>{status}</option>
                                                ))}
                                            </select>
                                            <label className="text-warning fw-bold"><FaCheckCircle className="me-1"/> Visa Application Status</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-5">
                                    <button className="btn btn-primary w-100 py-3 fw-bold fs-5 shadow-sm d-flex align-items-center justify-content-center gap-2 rounded-3">
                                        <FaSave /> SAVE VISA RECORD
                                    </button>
                                </div>
                            </form>
                        )}

                        {/* === NEWS FORM === */}
                        {activeTab === 'news' && (
                            <form onSubmit={handleNewsSubmit}>
                                <h4 className="mb-4 text-primary border-bottom pb-2 fw-bold">Post News Article</h4>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" value={newsForm.title} onChange={(e) => setNewsForm({...newsForm, title: e.target.value})} placeholder="Title" required />
                                    <label>Article Title</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" value={newsForm.image} onChange={(e) => setNewsForm({...newsForm, image: e.target.value})} placeholder="URL" required />
                                    <label>Image URL</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <textarea className="form-control" style={{height: '100px'}} value={newsForm.description} onChange={(e) => setNewsForm({...newsForm, description: e.target.value})} placeholder="Desc" required></textarea>
                                    <label>Short Description</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <textarea className="form-control" style={{height: '200px'}} value={newsForm.content} onChange={(e) => setNewsForm({...newsForm, content: e.target.value})} placeholder="Content" required></textarea>
                                    <label>Full Article Content</label>
                                </div>
                                <button className="btn btn-success w-100 py-3 fw-bold fs-5 shadow-sm rounded-3">
                                    <FaNewspaper className="me-2"/> PUBLISH NEWS
                                </button>
                            </form>
                        )}
                    </div>
                </div>

                {/* DB RECORD SECTION */}
                <div className="mt-5">
                    <div className="bg-white p-4 rounded-4 shadow-sm border-top border-4 border-warning">
                        <h4 className="text-center text-secondary mb-4 fw-bold">📂 Current Database Records</h4>
                        <VisaPage/>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Admin;